export const MODULE_NAME = 'AMENITY_MODULE';
